function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* ========================================================================
 * Apricot's Notification
 * ======================================================================== */

// SCSS
import "../scss/includes/apricot-base.scss";
import "../scss/includes/notification.scss";
import "../scss/includes/button.scss";

// javaScript
import Utils from "./CBUtils";

/**
 * Dismissible Notification
 *
 * @export
 * @param {Object} data
 * @param {Element} data.elem
 * @param {Boolean} data.remove
 * @param {Boolean} data.animation
 * @returns {{destroy: Function}}
 */
var Dismissible = function Dismissible() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultData = {
    elem: null,
    remove: false,
    animation: true
  };
  data = _objectSpread(_objectSpread({}, defaultData), data);
  var elem = data.elem;
  var close = null;
  if (!Utils.elemExists(elem)) return null;
  var init = function init() {
    elem.dismissibleNotification = "cb";
    close = elem.querySelector("[data-cb-notification-close]");
    if (!Utils.elemExists(close)) return null;
    close.addEventListener("click", hideNotification);
    if (useAnimation()) {
      window.addEventListener("resize", adjustNotificationHeight);
    }
  };
  var adjustNotificationHeight = function adjustNotificationHeight() {
    Utils.removeAttr(elem, "data-cb-height");
  };
  var hideNotification = function hideNotification(e) {
    if (e) e.preventDefault();
    var height = elem.offsetHeight;
    elem.style.height = height + "px";
    Utils.attr(elem, "data-cb-height", height);
    setTimeout(function () {
      elem.style.removeProperty("height");
      Utils.addClass(elem, "cb-notification-hide");
      Utils.attr(elem, "aria-hidden", "true");
      var event = new CustomEvent("apricot_notificationHidden");
      elem.dispatchEvent(event);
      if (data.remove) {
        setTimeout(function () {
          Utils.remove(elem);
        }, 60);
      } else {
        // a11y
        Array.from(elem.querySelectorAll(Utils.FOCUSABLE_ELEMENTS)).forEach(function (node) {
          Utils.attr(node, "tabIndex", "-1");
        });
      }
    }, 50);
  };
  var showNotification = function showNotification() {
    if (isNaN(Utils.attr(elem, "data-cb-height"))) {
      elem.style.height = "auto";
    } else {
      elem.style.height = Utils.attr(elem, "data-cb-height") + "px";
    }
    setTimeout(function () {
      Utils.removeClass(elem, "cb-notification-hide");
      Utils.removeAttr(elem, "aria-hidden");
      elem.style.removeProperty("height");
      var event = new CustomEvent("apricot_notificationShown");
      elem.dispatchEvent(event);
      // a11y
      Array.from(elem.querySelectorAll(Utils.FOCUSABLE_ELEMENTS)).forEach(function (node) {
        Utils.attr(node, "tabIndex", "0");
      });
    }, 50);
  };
  var useAnimation = function useAnimation() {
    return Utils.reduceMotionChanged() ? false : data.animation;
  };
  var destroy = function destroy() {
    if (elem.dismissibleNotification === "cb") {
      elem.dismissibleNotification = null;
      close.removeEventListener("click", hideNotification);
      if (useAnimation()) {
        window.removeEventListener("resize", adjustNotificationHeight);
      }
    }
  };
  if (elem.dismissibleNotification !== "cb") {
    init();
  }
  return {
    hideNotification: hideNotification,
    showNotification: showNotification,
    destroy: destroy
  };
};
var CBNotification = {
  Dismissible: Dismissible
};
export default CBNotification;
window.cb = window.cb || {};
window.cb.apricot = window.cb.apricot || {};
window.cb.apricot.CBNotification = CBNotification;